import { TaxonomyActionType } from '@modules/taxonomy/store/taxonomyActionType';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { useMuiModalContext } from '../Modal/ModalContext';

export const EditPromptConfirmationDialogContent = () => {
  const dispatch = useTaxonomyStore(({ dispatch }) => dispatch);

  const { closeModal } = useMuiModalContext();

  const onProceedClick = () => {
    dispatch({
      type: TaxonomyActionType.SET_CREATE_REASONV3_STATE,
      payload: {
        visual: {
          isEditPromptMode: true,
        },
      },
    });

    closeModal();
  };

  return (
    <>
      <DialogTitle>Edit Prompt?</DialogTitle>
      <Divider light />
      <DialogContent>
        <Typography variant="body1">
          Editing the prompt would reset selected Definitions. Are you sure you
          want to proceed?
        </Typography>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1 }}>
        <Button onClick={() => closeModal()} variant="outlined">
          Go Back
        </Button>
        <LoadingButton variant="contained" onClick={onProceedClick}>
          Proceed
        </LoadingButton>
      </DialogActions>
    </>
  );
};
